// extracted by mini-css-extract-plugin
module.exports = {"basicPageLayout":"styles_basicPageLayout__e40XV","content":"styles_content__imZHE"};